export default class SnackbarMessage {
    color: string = "";
    message: string = "";
    timeout: number = 3500;

    constructor(message: string, color: string, timeout: number ) {
        this.message = message;
        this.color = color;
        this.timeout = timeout;
    }
}